module.exports = __webpack_public_path__ + "img/11@2x.4b56b630.png";